export { ModularPageWrapper, ModulePageComponents } from './ModularPageWrapper';
